import React from "react";

// Top-down car schematic. Panel keys map to the settings panel dictionary.
const BODY_RECTS = [
  { key: "bumper_front", x: 46, y: 14, w: 108, h: 26, rx: 12, label: "Bumper" },
  { key: "fender_front_left", x: 24, y: 46, w: 28, h: 60, rx: 8, label: "F.Fndr" },
  { key: "bonnet_hood", x: 58, y: 46, w: 84, h: 60, rx: 8, label: "Bonnet" },
  { key: "fender_front_right", x: 148, y: 46, w: 28, h: 60, rx: 8, label: "F.Fndr" },
  { key: "door_front_left", x: 24, y: 112, w: 28, h: 50, rx: 6, label: "F.Door" },
  { key: "door_rear_left", x: 24, y: 166, w: 28, h: 50, rx: 6, label: "R.Door" },
  { key: "roof", x: 58, y: 112, w: 84, h: 104, rx: 10, label: "Roof" },
  { key: "door_front_right", x: 148, y: 112, w: 28, h: 50, rx: 6, label: "F.Door" },
  { key: "door_rear_right", x: 148, y: 166, w: 28, h: 50, rx: 6, label: "R.Door" },
  { key: "fender_rear_left", x: 24, y: 222, w: 28, h: 62, rx: 8, label: "R.Fndr" },
  { key: "boot_trunk", x: 58, y: 222, w: 84, h: 62, rx: 8, label: "Boot" },
  { key: "fender_rear_right", x: 148, y: 222, w: 28, h: 62, rx: 8, label: "R.Fndr" },
  { key: "bumper_rear", x: 46, y: 290, w: 108, h: 26, rx: 12, label: "Bumper" },
];

// Per-unit items drawn on both sides; the right side lights up only at qty 2
const SIDE_UNITS = [
  { key: "mirror_cap", x: 6, y: 100, w: 14, h: 18, rx: 4, label: "Mirror" },
  { key: "side_skirt", x: 6, y: 124, w: 10, h: 96, rx: 3, label: "Skirt" },
];

const TIER_STROKE = { none: "#F59E0B", small: "#10B981", medium: "#F59E0B", large: "#EF4444" };
const IDLE_FILL = "rgba(255,255,255,0.03)";
const IDLE_STROKE = "rgba(255,255,255,0.12)";
const ACTIVE_FILL = "rgba(245,158,11,0.22)";

const strokeFor = (sel) => (sel?.selected ? TIER_STROKE[sel.repair || "none"] : IDLE_STROKE);

function Shape({ r, x, active, stroke, testid }) {
  return (
    <rect x={x ?? r.x} y={r.y} width={r.w} height={r.h} rx={r.rx} data-testid={testid}
      fill={active ? ACTIVE_FILL : IDLE_FILL} stroke={active ? stroke : IDLE_STROKE} strokeWidth={active ? 2.3 : 1.2}
      className="transition-all duration-200" />
  );
}

function BodyPanel({ r, sel, onToggle }) {
  const active = !!sel?.selected;
  return (
    <g onClick={onToggle} style={{ cursor: "pointer" }} data-testid={`schematic-${r.key}`}>
      <Shape r={r} active={active} stroke={strokeFor(sel)} />
      {active && sel.special && <circle cx={r.x + r.w - 8} cy={r.y + 8} r="3.5" fill="#8B5CF6" />}
      <text x={r.x + r.w / 2} y={r.y + r.h / 2 + 3} textAnchor="middle" fontSize="9" fontFamily="Outfit, sans-serif" fontWeight="600"
        fill={active ? "#FDE68A" : "rgba(255,255,255,0.35)"} style={{ pointerEvents: "none" }}>
        {r.label}
      </text>
    </g>
  );
}

function SideUnit({ r, sel, onToggle }) {
  const qty = sel?.selected ? Number(sel.qty || 1) : 0;
  return (
    <g onClick={onToggle} style={{ cursor: "pointer" }}>
      <Shape r={r} active={qty >= 1} stroke={strokeFor(sel)} testid={`schematic-${r.key}`} />
      <Shape r={r} x={200 - r.x - r.w} active={qty >= 2} stroke={strokeFor(sel)} testid={`schematic-${r.key}-right`} />
      <title>{r.label}</title>
    </g>
  );
}

export default function CarSchematic({ selections, onToggle }) {
  return (
    <div className="relative w-full flex justify-center">
      <svg viewBox="0 0 200 330" className="w-full max-w-[240px]" role="img" aria-label="Vehicle panel map">
        <rect x="20" y="10" width="160" height="310" rx="34" fill="#0d1424" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" />
        <rect x="60" y="107" width="80" height="8" rx="3" fill="rgba(255,255,255,0.04)" />
        <rect x="60" y="213" width="80" height="8" rx="3" fill="rgba(255,255,255,0.04)" />
        {BODY_RECTS.map((r) => <BodyPanel key={r.key} r={r} sel={selections[r.key]} onToggle={() => onToggle(r.key)} />)}
        {SIDE_UNITS.map((r) => <SideUnit key={r.key} r={r} sel={selections[r.key]} onToggle={() => onToggle(r.key)} />)}
      </svg>
    </div>
  );
}
